import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import './styles.css';

const Dashboard = lazy(() => import('./components/Dashboard'));
const LogsPage = lazy(() => import('./pages/LogsPage'));

export default function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <div className="container">
        <Suspense fallback={<div className="page-loading">Chargement…</div>}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/logs" element={<LogsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}
